import useMutation from "src/hooks/useMutation";

function useCustomerUpdate(id) {
  return useMutation({
    path: `/api/v1/customers/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/customers`,
      shouldRevalidate: true,
    },
  });
}

export default useCustomerUpdate;
